package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Time
import kotlin.math.sqrt

class Sun(t: SP_Time) : OrbitalBody() {
    var lonSun = 0.0
        private set
    private val DEF_SUN_COLOR = SP_Colour(255, 255, 0,255)

    // Orbital elements of the Sun
    // (Actually the Earth, but customary to pretend that the Sun orbits the Earth)
    val OE_SUN = OrbitalElementsData(
        0.0, 0.0,
        0.0, 0.0,
        282.9404, 4.70935E-5,
        1.000000, 0.0,
        0.016709, -1.151E-9,
        356.0470, 0.9856002585
    )

    override fun recalculateEquatorialCoordinates(t: SP_Time) {
        recalculateOrbitalElements(t)
        val E = calculateFirstAproxOfE()
        calculateDistanceAndTrueAnomaly(E)

        // Compute the Sun's true longitude:
        lonSun = m_v + mOEs[w]

        // Convert lonsun,r to ecliptic rectangular geocentric coordinates xs,ys:
        val xs = m_r * MathD.cosD(lonSun)
        val ys = m_r * MathD.sinD(lonSun)

        // Convert to equatorial, rectangular, geocentric coordinates:
        val ye = ys * MathD.cosD(mEcl)
        val ze = ys * MathD.sinD(mEcl)
        itsRA = MathD.atanD2(ye, xs)
        itsDec = MathD.atanD2(ze, sqrt(xs * xs + ye * ye))
    }

    init {
        rgbColour = DEF_SUN_COLOR
        name = "Sun"
        abbrevName = "\u2609"
        setOrbitalElementsData(OE_SUN)
    }
}